import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-estado-periodo',
  templateUrl: './add-estado-periodo.component.html',
  styleUrls: ['./add-estado-periodo.component.css']
})
export class AddEstadoPeriodoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
